import { combineReducers } from "@reduxjs/toolkit";
import teacherSlice from "./teacherSlice";
import teacherAutocompleteSlice from "./teacherAutocompleteSlice";

export const teacherReducer = combineReducers({
  teachers: teacherSlice,
  autocompleteTeachers: teacherAutocompleteSlice,
});